import { CRUDService } from './crud-service.class'

export class OsfschetService extends CRUDService {
  subject = 'osfschet'

  parse = (p) => {
    return p
  }

  format = (o) => {
    return o
  }

  stats(params = {}) {
    return this.get({ _action: 'stats', ...params })
  }
}
